// extracted by mini-css-extract-plugin
export default {"header":"Header_header__KLdvi","content":"Header_content__HwWD2","title":"Header_title__Tvo1n","boxDarkMode":"Header_boxDarkMode__aajvw"};